<!-- 专管员、渠道部 管理首页页面 -->
<script>
// 加载中
import InnerLoading from '@/components/spinner/spinner.vue';
// 动态表单模版
import Temp from '@/components/technician/temp/index';
import {getLocalItem} from "@/untils/common";
import {
  branchInfoList3,
  consumablesWareHouseStockStatistics,
  // inspectionFlowtypenum,
  inspectionMobileInfoRatio,
  processFlowinit,
  processFlowlist, processRemove, processTasksNumber, processUserUnclaimed,
  salesManageInfo,
} from "@/lib/request";
export default {
  name:'techHome',
  data(){
    return{
      searchSiteId:'',
      innerLoading:false,
      // 动态表单模版
      returnObj:{},
      formDefine:{},
      formFields:[],
      flowNameObj:{},
      flagTemp:false,
      // ----------
      keys:0,
      nickName:'',
      postName:'',
      phone:'',
      roles:'',
      area:'',
      deptName:'',
      // categoryStr:'',
      listPramsObj:[
        // {
        //   "category": "http://www.flowable.org/processdef",
        //   "version": "1",
        //   "processDefinitionId": "1835-42af-11f0-b32c-3606515d593d",
        //   "processDefinitionName": "专管员-代销者变更"
        // },
        // {
        //   "category": "http://www.flowable.org/processdef",
        //   "version": "1",
        //   "processDefinitionId": "1836-42af-11f0-b32c-3606515d593d",
        //   "processDefinitionName": "专管员-经营类型变更"
        // },
        // {
        //   "category": "西藏-多租户",
        //   "version": "2",
        //   "processDefinitionId": "1834-42af-11f0-b32c-3606515d593d",
        //   "processDefinitionName": "专管员-信息更正"
        // }
      ],
      viewObj:{},
      viewDataObj:{},
      province:{},
      city:{},
      district:{},
      viewTaskObj:{},
      warehouseNameStr:'',
      objStatistics:{},
      removeListener: null,
      listTotal:null,
      welfareProfitList:[
        {name:'双色球',number:'9038900',reap:'20%'},
        {name:'快乐8',number:'9038900',reap:'25%'},
        {name:'3D',number:'9038900',reap:'11%'},
        {name:'七乐彩',number:'9038900',reap:'10%'},
        {name:'即开票',number:'9038900',reap:'10%'},
      ]
    }
  },
  components:{
    InnerLoading,
    Temp,
  },
  beforeDestroy() {
    if (this.removeListener) {
      this.removeListener()
    }
  },
  mounted() {
    this.initWechatBackListener()
  },
  methods:{
    getUrl(){
      let webUrl = true;//false:是测试; true:是 正式
      let urlSite = '';
      if(webUrl){
        urlSite = 'xztrain.joyveb.com';// 线上：https://xztrain.joyveb.com/
      }else{
        urlSite = 'testxztrain.joyveb.com';// 测试：https://testxztrain.joyveb.com
      }
      if(urlSite!==''){
        window.location.href=`https://${urlSite}?web=xz&nickName=${getLocalItem('nickName')}&roles=${getLocalItem('roles')}&phone=${getLocalItem('phone')}&deptName=${getLocalItem('deptName')}`;
      }
    },
    showConfirmModal() {
      this.getApiDel();
    },
    initWechatBackListener() {
      // 检测是否在微信环境中
      const isWechat = /micromessenger/i.test(navigator.userAgent.toLowerCase())

      if (isWechat) {
        // 添加历史记录
        window.history.pushState({ page: 'techHome' }, '', document.URL)

        // 定义处理函数
        const handleBack = (event) => {
          event.preventDefault()
          this.showConfirmModal()
        }

        // 添加事件监听
        window.addEventListener('popstate', handleBack, false)

        // 保存移除函数
        this.removeListener = () => {
          window.removeEventListener('popstate', handleBack, false)
        }
      }
    },
    getInspection(type){
      if(type==='1'){
        // 一般巡检
        this.$router.push({path:'/techListInspection'});
      }else if(type==='2'){
        // 专管员：待领取
        this.$router.push({path:'/techTask',query:{'active':'0'}});
        // this.$store.dispatch('setUrlName', 'techTask');
      }else if(type==='3'){
        // this.$router.push({path:'/techTask',query:{'active':'西藏-网点维护'}});
        // this.$store.dispatch('setUrlName', 'techTask');
      }else if(type==='4'){
        // 专管员：待领取
        this.$router.push({path:'/techTask',query:{'active':'0'}});
        // this.$store.dispatch('setUrlName', 'techTask');
      }else if(type==='5'){
        // 渠道部：待领取
        this.$router.push({path:'/techTask',query:{'active':'0'}});
        // this.$store.dispatch('setUrlName', 'techTask');
      }else if(type==='6'){
        //渠道部：未完成
        this.$router.push({path:'/techTask',query:{'active':'1'}});
        // this.$store.dispatch('setUrlName', 'techTask');
      }else if(type==='7'){
        //渠道部：已完成
        this.$router.push({path:'/techHistory'});
        // this.$store.dispatch('setUrlName', 'techHistory');
      }
    },
    // 流程表单提交接口
    getTempReturn(data){
      console.log(data)
      this.formFields = [];
      this.returnObj = {};
      this.formDefine = {};
      this.flagTemp = false;
      if(this.roles!=='渠道部'){
        // 销量数据
        this.getSaleData();
        // 巡检数量
        this.getInspectionNumber();
        // 任务数量
        // this.getTaskNumber();
        // 耗材库存
        this.getNumberState();
        //   待领取任务
        this.getWringTask()

      }else{
        this.getChang();
      }
    },
    // 创建流程表单接口
    getDefinitionFlow(titleNameObj){
      if(titleNameObj){
        processFlowinit({
          processDefinitionName: titleNameObj.processDefinitionName,
          processDefinitionId: titleNameObj.processDefinitionId,
          categoryName:titleNameObj.category
        }).then((res)=>{
          if(res){
            if(res.data){
              if(res.data.code===200){
                this.returnObj = res.data.data;
                let formDefine = JSON.parse(res.data.data.formDefine);
                console.log('流程创建',formDefine)
                if(formDefine){
                  this.formDefine = formDefine;
                  if(formDefine.fields.length>0){
                    formDefine.fields.map((v)=>{
                      v.id_name = '';
                      if(v.id.indexOf('Name')!==-1){
                        v.id_name = 'name'
                      }else if(v.id.indexOf('name')!==-1){
                        v.id_name = 'name'
                      }else if(v.id.indexOf('phone')!==-1){
                        v.id_name = 'phone'
                      }else if(v.id.indexOf('identity')!==-1){
                        v.id_name = 'identity'
                      }
                      if(v.params.customDesign){
                        if(v.params.customDesign.type==='fileupload'){
                          v.files = [];
                        }else if(v.params.customDesign.type==='rate'){
                          v.socre = 0;
                        }
                      }
                    });
                    this.flowNameObj = titleNameObj;
                    this.formFields = formDefine.fields;
                    this.flagTemp = true;
                  }
                }
              } else {
                this.$toast.fail(res.data.msg);
              }
              this.innerLoading = false;
            }
          }
        });
      }
    },
    getModel(type){
      this.innerLoading = true;
      if(type==='commuteClock'){
        this.$router.push({path:'/clockIn',query:{'type':'go_back'}});
      }else if(type==='AddressUpdate'){
        let titleNameObj = this.listPramsObj.find(item => item.arr_name === '信息更正');
        if(titleNameObj&&titleNameObj.processDefinitionName){
          this.getDefinitionFlow(titleNameObj);
          // this.$router.push({path:'/temp',query:{'processDefinitionName':titleNameObj.processDefinitionName,'processDefinitionId':titleNameObj.processDefinitionId,'categoryName':titleNameObj.category}});
        }else{
          this.innerLoading = false;
          this.$toast('暂无信息更正操作！');
        }
      }else if(type==='UserUpdate'){
        let titleNameObj = this.listPramsObj.find(item => item.arr_name === '代销者变更');
        if(titleNameObj&&titleNameObj.processDefinitionName){
          this.getDefinitionFlow(titleNameObj);
          // this.$router.push({path:'/temp',query:{'processDefinitionName':titleNameObj.processDefinitionName,'processDefinitionId':titleNameObj.processDefinitionId,'categoryName':titleNameObj.category}});
        }else{
          this.innerLoading = false;
          this.$toast('暂无代销者变更操作！');
        }
      }else if(type==='TypeUpdate'){
        let titleNameObj = this.listPramsObj.find(item => item.arr_name === '经营类型变更');
        if(titleNameObj&&titleNameObj.processDefinitionName){
          this.getDefinitionFlow(titleNameObj);
          // this.$router.push({path:'/temp',query:{'processDefinitionName':titleNameObj.processDefinitionName,'processDefinitionId':titleNameObj.processDefinitionId,'categoryName':titleNameObj.category}});
        }else{
          this.innerLoading = false;
          this.$toast('暂无经营类型变更操作！');
        }
      }else if(type==='RemoveUpdate'){
        let titleNameObj = this.listPramsObj.find(item => item.arr_name === '撤机');
        if(titleNameObj&&titleNameObj.processDefinitionName){
          this.getDefinitionFlow(titleNameObj);
          // this.$router.push({path:'/temp',query:{'processDefinitionName':titleNameObj.processDefinitionName,'processDefinitionId':titleNameObj.processDefinitionId,'categoryName':titleNameObj.category}});
        }else{
          this.innerLoading = false;
          this.$toast('暂无撤机操作！');
        }
      }else if(type==='special'){
        //   特殊巡检
        let titleNameObj = this.listPramsObj.find(item => item.arr_name === '特殊巡检');
        if(titleNameObj&&titleNameObj.processDefinitionName){
          this.getDefinitionFlow(titleNameObj);
          // this.$router.push({path:'/temp',query:{'processDefinitionName':titleNameObj.processDefinitionName,'processDefinitionId':titleNameObj.processDefinitionId,'categoryName':titleNameObj.category}});
        }else{
          this.innerLoading = false;
          this.$toast('暂无特殊巡检操作！');
        }
      }else if(type==='siteIdAdd'){
        //   网点录入
        let titleNameObj = this.listPramsObj.find(item => item.arr_name === '网点录入');
        if(titleNameObj&&titleNameObj.processDefinitionName){
          this.getDefinitionFlow(titleNameObj);
          // this.$router.push({path:'/temp',query:{'processDefinitionName':titleNameObj.processDefinitionName,'processDefinitionId':titleNameObj.processDefinitionId,'categoryName':titleNameObj.category}});
        }else{
          this.innerLoading = false;
          this.$toast('暂无网点录入操作！');
        }
      }else if(type==='consume'){
        this.innerLoading = false;
        // this.$toast('开发中，敬请期待！');
        this.$router.push({path:'/consume'});
      }else if(type==='setting'){
        // this.innerLoading = false;
        // this.$toast('开发中，敬请期待！');
        this.$router.push({path:'/setting'});
      }
    },
    // 专管员的流程类型
    getFlowList(){
      this.innerLoading = true;
      processFlowlist({}).then((res)=>{
        if(res){
          if(res.data){
            if(res.data.code===200){
              res.data.data.msgs.map((v)=>{
                if(v.processDefinitionName){
                  if(v.processDefinitionName.split('-')&&v.processDefinitionName.split('-').length>1){
                    v.arr_name = v.processDefinitionName.split('-')[1];
                  }else{
                    v.arr_name = v.processDefinitionName;
                  }
                }
              });
              // this.categoryStr = res.data.data.category;
              this.listPramsObj = res.data.data.msgs;
            }else{
              this.$toast.fail(res.data.msg);
            }
            this.innerLoading = false;
          }
        }
      });
    },
    // // 装撤移和网点维护数量展示数据
    // getTaskNumber(){
    //   inspectionFlowtypenum({}).then((res)=>{
    //     if(res) {
    //       if (res.data) {
    //         if (res.data.code === 200) {
    //           this.viewDataObj = res.data.data;
    //         }else{
    //           this.$toast(res.data.msg);
    //         }
    //       }
    //     }
    //   });
    // },
    getInspectionNumber(){
      inspectionMobileInfoRatio({}).then((res)=>{
        if(res) {
          if (res.data) {
            // if (res.data.code === 200) {
            this.viewObj = res.data;
            // }
          }
        }
      });
    },
    getSaleData(){
      salesManageInfo({}).then((res)=>{
        if(res){
          if(res.data){
            if(res.data.code===200){
              if(res.data.data&&res.data.data.gross){
                this.province = res.data.data.gross;
              }
              if(res.data.data&&res.data.data.responsible) {
                this.city = res.data.data.responsible;
              }
              if(res.data.data&&res.data.data.district) {
                this.district = res.data.data.district;
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    getChang(){
      processTasksNumber({}).then((res)=>{
        if(res){
          if(!res.data){
            return;
          }
          if(!res.data.data){
            return;
          }
          this.viewTaskObj = res.data.data;
        }
      });
    },
    getNumberState(){
      consumablesWareHouseStockStatistics({
        warehouseName:this.warehouseNameStr,
      }).then((res)=>{
        if(res){
          if(!res.data){
            return;
          }
          if(!res.data.data){
            return;
          }
          this.objStatistics = res.data.data;
        }
      });
    },
    getApiDel() {
      if(this.returnObj.processInstanceId){
        processRemove({
          processInstanceId: this.returnObj.processInstanceId
        }).then((res) => {
          if (res) {
            if (res.data) {
              if (res.data.code === 200) {
                this.flagTemp = false;
              } else {
                this.$toast(res.data.msg);
                return false;
              }
            }
          }
        });
      }
    },
    getWringTask(){
      processUserUnclaimed({
        pageSize: 20,//每页数量
        pageNum: 1,//当前页码
        category: '',
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              this.listTotal = res.data.data.total;
            } else {
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    //   搜索查询网点信息
    getQuerySiteIdInfo() {
      if (this.searchSiteId) {
        if(this.searchSiteId.length>7&&this.searchSiteId.length<10){
          branchInfoList3({
            pageNum:1,
            pageSize:10,
            branchId:this.searchSiteId
          }).then((res) => {
            if (res) {
              if (res.data) {
                if (res.data.code === 200) {
                  if(res.data.rows&&res.data.rows.length>0){
                    this.$router.push({path: '/techSiteIdInfo', query: {'siteId': this.searchSiteId}});
                  }else{
                    this.$toast(`暂无${this.searchSiteId}站点数据，请检查站点是否正确！`);
                    return false;
                  }
                }else{
                  this.$toast.fail(res.data.msg);
                  return false;
                }
                this.innerLoading = false;
              }
            }
          });
        } else {
          this.$toast('请输入正确的网点编号');
          return false;
        }
      } else {
        this.$toast('无网点编号');
        return false;
      }
    },
  },
  created() {
    if(getLocalItem('deptName')){
      if(getLocalItem('deptName').split('-')&&getLocalItem('deptName').split('-').length>0){
        if(getLocalItem('deptName').split('-')[1]){
          this.warehouseNameStr = getLocalItem('deptName').split('-')[1].substring(0,2);
        }else{
          this.warehouseNameStr = getLocalItem('deptName');
        }
      }
    }
    // 第一步
    // 获取流程类型：地址变更、代销者变更、经营类型变更等....
    this.getFlowList();
    // this.listPramsObj.map((v,k)=>{
    //   if(v.processDefinitionName){
    //     if(v.processDefinitionName.split('-')&&v.processDefinitionName.split('-').length>1){
    //       v.arr_name = v.processDefinitionName.split('-')[1]
    //     }
    //   }
    // });
    // -------缓存专管员的信息--------------
    let nickName = getLocalItem('nickName');
    let postName = getLocalItem('postName');
    let phone = getLocalItem('phone');
    let roles = getLocalItem('roles');
    let deptName = getLocalItem('deptName');
    // let arr_list = ['专管员','维修员']
    // arr_list.map((v,k)=>{
    //   if(roles.indexOf(v)!==-1){
    //     this.index = k;
    //   }
    // });
    // this.roles = arr_list[this.index];
    // let arr = ['拉萨','日喀则','山南','林芝','昌都','那曲','阿里'];
    // arr.map((v,k)=>{
    //   if(roles.indexOf(v)!==-1){
    //     this.keys = k;
    //   }
    // });
    // this.area = arr[this.keys]
    if(nickName){
      this.nickName = nickName;
    }
    if(postName){
      this.postName = postName;
    }
    if(phone){
      this.phone = phone;
    }
    if(deptName){
      this.deptName = deptName;
    }
    if(roles){
      this.roles = roles
    }
    if(roles!=='渠道部'){
      // 销量数据
      this.getSaleData();
      // 巡检数量
      this.getInspectionNumber();
      // 任务数量
      // this.getTaskNumber();
      // 耗材库存
      this.getNumberState();
      //   待领取任务
      this.getWringTask()

    }else{
      this.getChang();
    }
  }
}
</script>
<template>
  <div class="tech-content">
    <!--   加载中...-->
    <inner-loading v-model="innerLoading"></inner-loading>
    <!--   动态表单模版-->
    <Temp v-model="flagTemp" content="del" :historyList="[]" :variablesObj="{}" :siteIdObj="{}" :flowNameObj="flowNameObj" :returnObj="returnObj" :formDefine="formDefine" :formFields="formFields" @submit="getTempReturn"></Temp>
    <!--   网点编号 搜索-->
    <div class="search-group" v-if="roles==='渠道部'||roles==='专管员'">
      <div class="search-item">
        <van-field
            v-model="searchSiteId"
            name="name"
            label=""
            type="number"
            autocomplete="off"
            placeholder="请输入网点编号"
        />
        <van-button block type="primary" class="btn-search" style="background: #e62d2d" size="normal" color="#e62d2d" @click="getQuerySiteIdInfo()">搜索</van-button>
      </div>
    </div>
    <!-- 专管员和分拣员可见 -->
    <!-- 全区总销量 -->
    <div class="sales-area" v-if="roles!=='渠道部'">
      <div class="sales-tit"><span></span>月度销量统计</div>
      <div class="sales-area-all">
        <div class="sales-area-title">自治区全区</div>
        <div class="sales-area-title">责任区域</div>
      </div>
      <div class="sales-area-all">
        <div class="total-sales">
          <div class="total-sales-value">
            <span>总销量：</span>
            <span v-if="province&&province.collect">{{ province&&province.collect|formatNumberData }}</span>
            <span v-else>0</span>
          </div>
        </div>
        <div class="total-sales">
          <div class="total-sales-value">
            <span>总销量：</span>
            <span v-if="city&&city.collect">{{city&&city.collect |formatNumberData}}</span>
            <span v-else>0</span>
          </div>
        </div>
      </div>
      <div class="sales-area-num">
        <div class="sales-data">
          <div class="sales-data-item">
            <div class="sales-label">电脑票</div>
            <div class="sales-value">
              <span v-if="province&&province.computicketsSales">{{ province&&province.computicketsSales|formatNumberData }}</span>
              <span v-else>0</span>
            </div>
          </div>
          <div class="sales-data-item">
            <div class="sales-label">即开票</div>
            <div class="sales-value">
              <span v-if="province&&province.instantGamesSales">{{ province&&province.instantGamesSales|formatNumberData }}</span>
              <span v-else>0</span>
            </div>
          </div>
        </div>
        <div class="sales-data">
          <div class="sales-data-item">
            <div class="sales-label">电脑票</div>
            <div class="sales-value">
              <span v-if="city&&city.computicketsSales">{{ city&&city.computicketsSales|formatNumberData }}</span>
              <span v-else>0</span>
            </div>
          </div>
          <div class="sales-data-item">
            <div class="sales-label">即开票</div>
            <div class="sales-value">
              <span v-if="city&&city.instantGamesSales">{{city&&city.instantGamesSales|formatNumberData}}</span>
              <span v-else>0</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="district&&district.collect" style="border-bottom: 1px rgba(0, 0, 0, 0.04) solid;padding-top: 10px ;margin-bottom: 10px"></div>
      <div v-if="district&&district.collect" class="sales-area-all">
        <div class="sales-area-title">所属片区</div>
        <div class="sales-area-title"></div>
      </div>
      <div v-if="district&&district.collect" class="sales-area-all">
        <div class="total-sales">
          <div class="total-sales-value">
            <span>总销量：</span>
            <span v-if="district&&district.collect">{{ district&&district.collect|formatNumberData }}</span>
            <span v-else>0</span>
          </div>
        </div>
        <div class="total-sales"></div>
      </div>
      <div v-if="district&&district.collect" class="sales-area-num">
        <div class="sales-data">
          <div class="sales-data-item">
            <div class="sales-label">电脑票</div>
            <div class="sales-value">
              <span v-if="district&&district.computicketsSales">{{ district&&district.computicketsSales|formatNumberData }}</span>
              <span v-else>0</span>
            </div>
          </div>
          <div class="sales-data-item">
            <div class="sales-label">即开票</div>
            <div class="sales-value">
              <span v-if="district&&district.instantGamesSales">{{ district&&district.instantGamesSales|formatNumberData }}</span>
              <span v-else>0</span>
            </div>
          </div>
        </div>
        <div class="sales-data">
          <div class="sales-data-item">

          </div>
          <div class="sales-data-item">

          </div>
        </div>
      </div>
    </div>
    <!--  新增需求 渠道部单一角色可见  -->
    <div class="card" v-if="roles==='渠道部'">
      <div class="card-title">
        <span>📋 绩效管理</span>
      </div>
      <div class="function-grid">
        <div class="function-card" @click="getModel('setting')">
          <div class="function-icon"><span>🗒</span></div>
          <div class="function-name">设置绩效</div>
        </div>
      </div>
    </div>
    <!-- 单一角色分拣员不可见 -->
    <!-- 工作任务 -->
    <div class="card" v-if="roles!=='分拣员'">
      <div class="card-title">
        <span>📋 工作任务</span>
      </div>
      <div class="function-grid" style="grid-template-columns: repeat(3, 1fr); gap: 10px; margin-bottom: 0!important;">
        <div class="function-card inspection-items" v-if="roles!=='渠道部'" @click="getInspection('1')" style="height: 80px;" >
          <div class="function-name">巡检网点</div>
          <div class="task-count" v-if="(parseInt(viewObj.total)-parseInt(viewObj.complete))>0">{{parseInt(viewObj.total)-parseInt(viewObj.complete)}}</div>
          <div class="tack-green" v-else>0</div>
        </div>
        <div class="function-card inspection-items" v-if="roles!=='渠道部'" @click="getInspection('2')" style="height: 80px;" >
          <div class="function-name">待处理</div>
          <div class="task-count" v-if="listTotal>0">{{listTotal}}</div>
          <div class="tack-green" v-else>0</div>
        </div>
        <div class="function-card inspection-item" v-if="roles==='渠道部'" @click="getInspection('5')" style="height: 80px;" >
          <div class="function-name">待处理</div>
          <!--          <div class="task-count">{{viewTaskObj.unclaimed}}</div>-->
          <div class="task-count" v-if="viewTaskObj.unclaimed>0">{{viewTaskObj.unclaimed}}</div>
          <div class="tack-green" v-else>0</div>
        </div>
        <div class="function-card inspection-items" v-if="roles==='渠道部'" @click="getInspection('6')" style="height: 80px;" >
          <div class="function-name">未完成</div>
          <!--          <div class="task-count">{{viewTaskObj.unfinished}}</div>-->
          <div class="task-count" v-if="viewTaskObj.unfinished>0">{{viewTaskObj.unfinished}}</div>
          <div class="tack-green" v-else>0</div>
        </div>
        <div class="function-card inspection-items" v-if="roles==='渠道部'" @click="getInspection('7')" style="height: 80px;" >
          <div class="function-name">已完成</div>
          <!--          <div class="task-count">{{viewTaskObj.completed}}</div>-->
          <div class="task-count" v-if="viewTaskObj.completed>0">{{viewTaskObj.completed}}</div>
          <div class="tack-green" v-else>0</div>
        </div>
      </div>
    </div>
    <!-- 单一角色分拣员不可见 -->
    <!-- 功能区 -->
    <div class="card" v-if="roles!=='分拣员'">
      <div class="card-title">
        <span>⚡ 网点管理</span>
      </div>
      <div class="function-grid">
        <div class="function-card" v-if="roles!=='渠道部'" @click="getModel('commuteClock')">
          <div class="function-icon"><span>⏰</span></div>
          <div class="function-name">考勤打卡</div>
        </div>
        <div class="function-card" v-if="roles!=='渠道部'" @click="getModel('AddressUpdate')">
          <div class="function-icon"><van-icon name="location" /></div>
          <div class="function-name">地址更正</div>
        </div>
        <!--        <div class="function-card" @click="getModel('UserUpdate')">-->
        <!--          <div class="function-icon"><van-icon name="manager" /></div>-->
        <!--          <div class="function-name">代销者变更</div>-->
        <!--        </div>-->
        <div class="function-card" v-if="roles!=='渠道部'" @click="getModel('TypeUpdate')">
          <div class="function-icon"><i class="el-icon-refresh"></i></div>
          <div class="function-name">经营类型变更</div>
        </div>
        <div class="function-card" @click="getModel('RemoveUpdate')">
          <div class="function-icon"><i class="el-icon-remove-outline"></i></div>
          <div class="function-name">发起撤机</div>
        </div>
        <div class="function-card " v-if="roles==='渠道部'" @click="getModel('special')" style="height: 80px;" >
          <div class="function-icon"><van-icon name="send-gift" /></div>
          <div class="function-name">特殊巡检</div>
        </div>
        <div class="function-card" @click="getModel('siteIdAdd')">
          <div class="function-icon"><i class="el-icon-coordinate"></i></div>
          <div class="function-name">网点录入</div>
        </div>
        <div class="function-card" @click="getUrl" v-if="roles==='专管员'">
          <div class="function-icon"><van-icon name="desktop-o" /></div>
          <div class="function-name">培训平台</div>
        </div>
      </div>
    </div>
    <!--   专管员 新增加的布局和统计数量     -->
    <!--    <div class="card" v-if="roles==='专管员'">-->
    <!--      <div class="card-title">-->
    <!--        <span>🎁 公益金统计</span>-->
    <!--      </div>-->
    <!--      <div class="function-grid" style="grid-template-columns: repeat(3, 1fr); gap: 10px; margin-bottom: 0!important;">-->
    <!--        <div class="function-card inspection-items" style="height: 80px;" v-for="(item,index) in welfareProfitList" :key="index">-->
    <!--          <div class="function-name">{{item.name}}</div>-->
    <!--          <div class="task-count">￥{{item.number}}</div>-->
    <!--          <div class="function-name">公益金：{{item.reap}}</div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="card" v-if="roles==='专管员'">-->
    <!--      <div class="card-title">-->
    <!--        <span>📈 任务统计</span>-->
    <!--      </div>-->
    <!--      <div class="function-grid" style="grid-template-columns: repeat(4, 1fr); gap: 10px; margin-bottom: 0!important;">-->
    <!--        <div class="function-card inspection-items" style="height: 80px;" >-->
    <!--          <div class="function-name">装机</div>-->
    <!--          <div class="task-count">{{parseInt(viewObj.total)-parseInt(viewObj.complete)}}</div>-->
    <!--        </div>-->
    <!--        <div class="function-card inspection-items" style="height: 80px;" >-->
    <!--          <div class="function-name">撤机</div>-->
    <!--          <div class="task-count">{{parseInt(viewObj.total)-parseInt(viewObj.complete)}}</div>-->
    <!--        </div>-->
    <!--        <div class="function-card inspection-items" style="height: 80px;" >-->
    <!--          <div class="function-name">移机</div>-->
    <!--          <div class="task-count">{{parseInt(viewObj.total)-parseInt(viewObj.complete)}}</div>-->
    <!--        </div>-->
    <!--        <div class="function-card inspection-items" style="height: 80px;" >-->
    <!--          <div class="function-name">巡检</div>-->
    <!--          <div class="task-count">{{parseInt(viewObj.total)-parseInt(viewObj.complete)}}</div>-->
    <!--        </div>-->
    <!--        <div class="function-card inspection-items" style="height: 80px;" >-->
    <!--          <div class="function-name">代销者变更</div>-->
    <!--          <div class="task-count">{{parseInt(viewObj.total)-parseInt(viewObj.complete)}}</div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="card" v-if="roles==='专管员'">-->
    <!--      <div class="card-title">-->
    <!--        <span>🏪 当前网点动态</span>-->
    <!--      </div>-->
    <!--      <div class="function-grid" style="grid-template-columns: repeat(3, 1fr); gap: 10px; margin-bottom: 0!important;">-->
    <!--        <div class="function-card inspection-items" style="height: 80px;" >-->
    <!--          <div class="function-name">正常营业</div>-->
    <!--          <div class="task-count">{{parseInt(viewObj.total)-parseInt(viewObj.complete)}}</div>-->
    <!--          <div class="function-name">个</div>-->
    <!--        </div>-->
    <!--        <div class="function-card inspection-items" style="height: 80px;" >-->
    <!--          <div class="function-name">暂停营业</div>-->
    <!--          <div class="task-count">{{parseInt(viewObj.total)-parseInt(viewObj.complete)}}</div>-->
    <!--          <div class="function-name">个</div>-->
    <!--        </div>-->
    <!--        <div class="function-card inspection-items" style="height: 80px;" >-->
    <!--          <div class="function-name">撤机</div>-->
    <!--          <div class="task-count">{{parseInt(viewObj.total)-parseInt(viewObj.complete)}}</div>-->
    <!--          <div class="function-name">个</div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!-- 渠道部不可见 -->
    <!-- 热敏纸记录 -->
    <div class="card" v-if="roles!=='渠道部'">
      <div class="card-title">
        <span>热敏纸记录</span>
      </div>
      <div class="function-grid" style="grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 0;">
        <div class="function-card" @click="getModel('consume')">
          <div class="function-icon"><van-icon name="shop" /></div>
          <div class="function-name">当前库存:{{objStatistics.boxNumber}}箱</div>
          <div class="function-name">本月出库:{{objStatistics.currentMonthOutboundNumber}}箱</div>
          <div class="function-name">待出库:{{objStatistics.tobeOutboundNumber}}箱</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.tech-content{
  font-size: 28px;
  padding-top: 105px;
  box-sizing: border-box;
  .search-group{
    display: flex;
    flex-flow: column;
    .search-item{
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      gap: 10px;
      padding: 0 0 20px;
      .van-cell{
        border-radius: 10px;
        border: 2px solid #ddd;
      }
      .btn-search{
        width: 200px;
        padding: 10px;
        border-radius: 10px;
        //border-color:#2196F3 !important;
        //background:linear-gradient(135deg, #2196F3 0%, #1976D2 100%) !important;
      }
    }
  }
}

/* 销售数据卡片样式 */
.sales-area {
  background: white;
  border-radius: 10px;
  padding: 20px 0;
  margin-bottom: 15px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
  border: 1px solid rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
}
.sales-tit{
  padding:0 25px 10px;
  font-weight: bold;
  font-size: 30px;
  span{
    display: inline-block;
    vertical-align: middle;
    margin-top: -6px;
    width: 10px;
    height: 30px;
    background: #e62d2d;
    margin-right: 10px;
  }
}
.sales-area-all{
  display: flex;
  flex-direction: row;
}
.sales-area-num{
  display: flex;
  flex-direction: row;
}
.sales-area-title {
  width: 100%;
  font-weight: bold;
  color: #333;
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 15px;
}


.sales-data {
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
}

.sales-data-item {
  flex: 1;
  text-align: center;
  padding: 0 5px;
}

//.sales-data-item:last-child {
//  border-right: none;
//}

.sales-label {
  color:#666;
  margin-bottom: 15px;
}

.sales-value {
  font-weight: bold;
  color:#e62d2d;
  margin: 5px 0;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.sales-value span {
  font-weight: bold;
  color:#e62d2d;
}
.total-sales-value {
  font-size: 36px;
  font-weight: bold;
  color: #e62d2d;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.total-sales-value span {
  font-size: 26px;
  font-weight: bold;
  margin-left: 2px;
}
.total-sales {
  display: flex;
  width: 100%;
  text-align: center;
  justify-content: center;
  padding-bottom: 10px;
}
.card-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;
}
/* 工作任务卡片 */
.function-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-bottom: 0;
}

.function-card {
  background: white;
  border-radius: 6px;
  padding:14px 14px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
  border: 1px solid rgba(0,0,0,0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  position: relative;
  min-height: 100px;
}

.function-card:active {
  transform: translateY(1px);
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.inspection-items {
  background: linear-gradient(135deg, #fff, #f9f9f9);
}

.function-icon {
  font-size: 24px;
  margin-bottom: 5px;
  color: #e62d2d;
  i{
    font-size: 44px;
  }
  span{
    font-size: 38px;
  }
}

.function-name {
  font-size: 24px;
  color: #333;
  font-weight: 500;
}
.task-count {
  font-size: 26px;
  font-weight: bold;
  color: #e62d2d;
  margin-top: 15px;
  position: relative;
}
.tack-green{
  font-size: 26px;
  font-weight: bold;
  color: green;
  margin-top: 15px;
}
.task-count::before {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: rgba(230, 45, 45, 0.1);
  border-radius: 2px;
  z-index: -1;
}
</style>